import type { BetterDoc } from "@/types/__generated__/union-types"

export const isBetterDocOffered = (betterDocUsage: BetterDoc | null): boolean =>
  betterDocUsage === "ALLOWED" || betterDocUsage === "REQUIRED" || betterDocUsage === "CONDITION_PACKAGE"
